// extracted by mini-css-extract-plugin
module.exports = {"block":"_16215","hd":"_8237","icon":"_15353","title":"_9775","grow":"_3218","arrow":"_5642","bd":"_8805"};